// Basit oturum yönetimi. Yönetim girişi yalnız erişim anahtarı döndürür
// (yenileme anahtarı yok), bu yüzden token localStorage'da tutulur ve
// süresi dolduğunda / 401 alındığında yeniden giriş istenir.

const ANAHTAR = 'at_panel_token';
const BITIS = 'at_panel_bitis';
const AD = 'at_panel_ad';

export function oturumKaydet({ erisimAnahtari, erisimAnahtariBitisUtc, adSoyad }) {
  localStorage.setItem(ANAHTAR, erisimAnahtari);
  if (erisimAnahtariBitisUtc) localStorage.setItem(BITIS, erisimAnahtariBitisUtc);
  if (adSoyad) localStorage.setItem(AD, adSoyad);
}

export function token() {
  const t = localStorage.getItem(ANAHTAR);
  if (!t) return null;
  const bitis = localStorage.getItem(BITIS);
  if (bitis && new Date(bitis).getTime() < Date.now()) {
    // Süresi dolmuş
    oturumTemizle();
    return null;
  }
  return t;
}

export function adSoyad() {
  return localStorage.getItem(AD) || 'Yönetici';
}

export function girisYapildiMi() {
  return !!token();
}

export function oturumTemizle() {
  localStorage.removeItem(ANAHTAR);
  localStorage.removeItem(BITIS);
  localStorage.removeItem(AD);
}
